export class ScreenRowApiModel {
  id: string;

  legend: string;

  coordinate: number;
}
